<div class="popup-container">
  <img src="assets/screen_rotation.svg" alt="rotate-screen" class="rotate-icon" />
  <div class="text">Please rotate your screen to get a better visual of the graph</div>
    <button mat-dialog-close mat-icon-button (click)="onClose()">
    <span class="material-icons">cancel</span>
  </button>
</div>
